import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useCompanyContacts } from '../../../hooks/useCompanyContacts';
import JobContactForm from './JobContactForm';
import type { Contact } from '../../../types/contact';

interface AddJobContactPopupProps {
  jobId: string;
  companyId: string;
  onClose: () => void;
  onSuccess: () => void;
}

export default function AddJobContactPopup({ jobId, companyId, onClose, onSuccess }: AddJobContactPopupProps) {
  const { contacts, loading, error } = useCompanyContacts(companyId);
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-dark-800 rounded-lg max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Add Contact</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {loading ? (
          <div className="text-gray-400">Loading contacts...</div>
        ) : error ? (
          <div className="text-red-500">Failed to load contacts</div>
        ) : contacts.length === 0 ? (
          <div className="text-gray-400">No contacts found for this company</div>
        ) : !selectedContact ? (
          <div className="space-y-4">
            <p className="text-gray-400">Select a contact to add:</p>
            <div className="space-y-2">
              {contacts.map(contact => (
                <button
                  key={contact.id}
                  onClick={() => setSelectedContact(contact)}
                  className="w-full text-left p-3 rounded-lg bg-dark-700 hover:bg-dark-600 transition-colors"
                >
                  <p className="font-medium">{contact.first_name} {contact.last_name}</p>
                  {contact.job_title && (
                    <p className="text-sm text-gray-400">{contact.job_title}</p>
                  )}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <JobContactForm
            jobId={jobId}
            contact={selectedContact}
            onSuccess={onSuccess}
            onCancel={() => setSelectedContact(null)}
          />
        )}
      </div>
    </div>
  );
}